import NossoNumero from './NossoNumero';

export default NossoNumero;
